<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-layout row>
      <v-flex class="xs12 sm12 lg12">
        <div class="body-2 font-weight-bold nav nav-tabs white">
          <!-- /.tabrow -->
          <li class="">
            <a
              >Current selection (1 product x 1 target market)
              <help-link help_id="11" style="float: right" />
            </a>
          </li>
        </div>
      </v-flex>
    </v-layout>
    <div class="tab-content">
      <div class="tab-pane active white">
        <v-container fluid>
          <v-layout class="justify-space-between align-center mt-0 mr-1" row>
            <v-flex sm12 class="ml-2">
              <applied_filters_box class="mb-3"></applied_filters_box>
            </v-flex>

            <v-flex
              v-show="$store.getters.selectionCounts.products > 0"
              class="result_box_bottom_border mb-1"
              sm1
            >
              <v-tooltip left>
                <template v-slot:activator="{on, attrs}">
                  <v-icon v-on="on" @click="$store.commit('toggleProductsFilter', true)"
                    >mdi-dolly
                  </v-icon>
                  :dd
                </template>
                <span>Click to open product filters</span>
              </v-tooltip>

              <span>
                {{ $store.getters.getDsmAppState.dsm_filter_setttings['HS6_Code'] }}
              </span>
            </v-flex>

            <v-flex class="result_box_bottom_border ml-5" sm12>
              <span>
                <v-tooltip left>
                  <template v-slot:activator="{on, attrs}">
                    <v-icon v-on="on" @click="$store.commit('toggleProductsFilter', true)"
                      >mdi-earth</v-icon
                    >:
                  </template>
                  <span>Click to open market filters</span>
                </v-tooltip>

                <v-tooltip
                  left
                  v-if="
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                      .markets.C_Code.length > 0 &&
                      $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                        .products.HS6_Code.length > 0
                  "
                >
                  <template v-slot:activator="{on, attrs}">
                    <span>
                      <a
                        :href="itc_countries_url"
                        target="_blank"
                        class="align-center"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-img
                          class="d-inline-block mb-auto mt-auto"
                          contain
                          max-width="40"
                          src="../../../assets/img/itc-logo.gif"
                        ></v-img
                      ></a>
                    </span>
                  </template>
                  <span>Click to view ITC tariff information</span>
                </v-tooltip>
              </span>
              <span> {{ showCountries() }}</span>
            </v-flex>
          </v-layout>

          <v-layout class="justify-space-between align-end align-center mt-2 ml-2" row>
            <v-flex class="result_box_no_border sm12">
              <span v-show="$store.getters.selectionCounts.products === 0">
                <v-tooltip left>
                  <template v-slot:activator="{on, attrs}">
                    <v-icon v-on="on" @click="$store.commit('toggleProductsFilter', true)"
                      >mdi-dolly</v-icon
                    >:
                  </template>
                  <span>Click to open product filters</span>
                </v-tooltip>
              </span>
              <span v-show="$store.getters.selectionCounts.products > 0">
                <v-icon @click="$store.commit('toggleProductsFilter', true)"
                  >mdi-text-box-outline</v-icon
                >:
              </span>

              <v-tooltip
                left
                v-if="
                  this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                    .products.HS6_Code.length > 0
                "
              >
                <template v-slot:activator="{on, attrs}">
                  <span>
                    <a
                      :href="itc_products_url"
                      target="_blank"
                      class="align-center"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-img
                        class="d-inline-block mb-auto mt-auto"
                        contain
                        max-width="40"
                        src="../../../assets/img/itc-logo.gif"
                      ></v-img
                    ></a>
                  </span>
                </template>
                <span>Click to view ITC product code history</span>
              </v-tooltip>

              <span
                v-if="
                  this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                    .products.HS6_Code.length > 0
                "
              >
                [{{ single_product }}] {{ hs6_codeToDescription(single_product) }}
              </span>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>

    <DsmSingleTextFilters
      v-if="
        !$store.state.tradeDSM.loading_indicator &&
          !$store.state.tradeDSM.productsOpen &&
          !$store.state.tradeDSM.countriesOpen &&
          $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
            .combinations > 0
      "
    />
    <template v-else>
      <p class="outline mt-12 text-h5 pa-4">
        There are no results for the current set of applied filters, product and market
        selections. More details about the current applied selections can be found in the
        'Details' tab above. <br /><br />
        <v-btn
          @click="run_cube_clear_filters"
          class="red white--text"
          v-if="
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress ===
              true &&
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations
                .combinations === 0
          "
          >Reset Filters and Rerun
        </v-btn>
      </p>
    </template>
  </div>
</template>
<script>
import DsmSingleTextFilters from '@/components/trade-dsm-application/result-components/text-filters-1p1c';
import {mapGetters} from 'vuex';
import applied_filters_box from '@/components/trade-dsm-application/results-pages/applied-filters-box';
import helpLink from '@/components/application-level/help-system/help-link';

export default {
  name: 'dsm-single-text-prod-country',
  components: {
    DsmSingleTextFilters,
    applied_filters_box,
    helpLink,
  },
  computed: {
    ...mapGetters(['getDsmAppState', 'single_product']),

    itc_countries_url() {
      const home_market_code = this.$store.state.tradeDSM.dsm_filter_setttings.Home_Market.slice(
        1,
      );

      let target_market_code = '';
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code.length > 0
      ) {
        target_market_code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code[0].slice(
          1,
        );
      } else {
        target_market_code = '';
      }

      const hs6_code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code[0].slice(
        2,
      );

      let year = 'none';
      try {
        year = this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult[0][
          'ad_valorem_tariff_year'
        ];
      } catch (e) {
        year = 2020;
      }

      return `https://macmap.org/en/query/customs-duties?reporter=${
        target_market_code === '158' ? '490' : target_market_code
      }&year=${year}&partner=${home_market_code}&product=${hs6_code}&level=6`;
    },

    itc_products_url() {
      const code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code[0].slice(
        2,
      );

      return `https://legacy.trademap.org/stCorrespondingProductCodes.aspx?nvpm=1%7c%7c%7c%7c%7c${code}%7c%7c%7c%7c%7c%7c%7c2%7c%7c%7c%7c%7c1`;
    },
    valid_results() {
      try {
        let result_status = true;
        if (
          'result' in this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult[0]
        ) {
          if (
            this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult[0][
              'result'
            ] === null
          ) {
            result_status = false;
          } else {
            result_status = true;
          }
        }
        return (
          this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult &&
          result_status
        );
      } catch (e) {
        return false;
      }
    },
  },
  methods: {
    async run_cube_clear_filters() {
      // backup the current selection if any
      let product_backup = [];
      let market_backup = [];

      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
          .HS6_Code.length > 0
      ) {
        product_backup = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
          .selections.products.HS6_Code;
      } else {
        product_backup = [];
      }

      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code.length > 0
      ) {
        market_backup = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
          .selections.markets.C_Code;
      } else {
        market_backup = [];
      }

      // clear the filters to a state of no filters.
      await this.reset_filters('FILTERS');

      // add the selection back to the state
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = product_backup;

      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = market_backup;

      // now update the cube again.
      await this.update_results_cube();
    },

    showCountries() {
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code.length > 0
      ) {
        return this.$store.getters.countriesSelectorList.filter(
          c =>
            c['C_Code'] ===
            this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
              .markets.C_Code[0],
        )[0]['C_Name'];
      } else {
        return 'No market selected.';
      }
    },
  },
};
</script>
<style scoped>
.highlight {
  color: #419d78;
}

.result_box {
  color: green;

  text-align: left;
  outline: lightgrey solid 1px;
  margin: 0;

  padding-left: 3px;
}

.result_box_no_border {
  color: green;

  text-align: left;

  padding-left: 3px;
}

.result_box_bottom_border {
  color: green;

  text-align: left;

  border-bottom: 1px dashed lightgrey;
  padding-left: 2px;
}

.disabled {
  pointer-events: none;
}
</style>
